var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"empty-list"},[_c('h1',[_vm._v("Oops!")]),_c('p',[_vm._v("We can't seem to find what you're looking for.")]),_c('img',{staticStyle:{"width":"9em","margin":"2em","opacity":"0.6"},attrs:{"src":require("@/assets/img/sadface.png")}})])])
}]

export { render, staticRenderFns }